import React, { useEffect, useRef } from "react";
import { FormBuilderElementsMappingService } from "../../../../services/builder/form-builder.elements-mapping.service";
import { useFormData } from "../../../../hooks/client/use-form-data";
export const termsAndConditionsLabelKey = "FORM.DIV DIV-COMMUNITY-CONSENT.TERMS-AND-CONDITIONS_LABEL";
export const privacyPolicyLabelKey = "FORM.DIV DIV-COMMUNITY-CONSENT.PRIVACY-POLICY-LABEL";
export const communityUrlKey = "FORM.DIV DIV-COMMUNITY-CONSENT.COMMUNITY-URL";
export const communityNameKey = "FORM.DIV DIV-COMMUNITY-CONSENT.COMMUNITY-NAME";
export const communityAgeKey = "FORM.DIV DIV-COMMUNITY-CONSENT.COMMUNITY-AGE";
const FormBuilderFormInterfaceCommunityConsent = ({ item, analyticForm, t }) => {
  if (!item) return null;
  const { formDataSetters, formData } = useFormData();
  const inputRef = useRef(null);
  const { input: checkbox, label } = FormBuilderElementsMappingService.getSingleElementHTMLTags(item);
  const defaultChecked = (formData == null ? void 0 : formData[checkbox.name]) === (checkbox == null ? void 0 : checkbox.value);
  const onFocus = () => {
    analyticForm == null ? void 0 : analyticForm.trackInputFocused(checkbox.name);
  };
  const onBlur = () => analyticForm == null ? void 0 : analyticForm.trackInputBlurred(checkbox.name);
  const communityName = t(communityNameKey);
  const communityUrl = t(communityUrlKey);
  const communityAge = t(communityAgeKey);
  const communityTermsAndConditionsLink = `<a href="${communityUrl}/policies/terms_conditions" target="_blank">${t(
    termsAndConditionsLabelKey
  )}</a>`;
  const communityPrivacyPolicyLink = `<a href="${communityUrl}/policies/privacy" target="_blank">${t(
    privacyPolicyLabelKey
  )}</a>`;
  const textHtml = t(label.nodeValue, {
    minimum_age: communityAge,
    name: communityName,
    terms_link: communityTermsAndConditionsLink,
    privacy_policy_link: communityPrivacyPolicyLink
  });
  const dataMapping = checkbox == null ? void 0 : checkbox["data-mapping"];
  const dataMappingObj = dataMapping ? JSON.parse(dataMapping) : {};
  const isEmailEmpty = !(formData == null ? void 0 : formData[dataMappingObj == null ? void 0 : dataMappingObj.email]);
  useEffect(() => {
    const consentInputElement = inputRef.current;
    if (consentInputElement) {
      if (isEmailEmpty) {
        consentInputElement.disabled = true;
        consentInputElement.checked = false;
        formDataSetters.setInputValue(checkbox.name, void 0);
      } else {
        consentInputElement.disabled = false;
      }
    }
  }, [checkbox, isEmailEmpty]);
  return /* @__PURE__ */ React.createElement("div", { className: `${item.class}` }, /* @__PURE__ */ React.createElement(
    "input",
    {
      ref: inputRef,
      type: checkbox == null ? void 0 : checkbox.type,
      name: checkbox == null ? void 0 : checkbox.name,
      onFocus,
      onBlur,
      id: checkbox == null ? void 0 : checkbox.id,
      required: checkbox == null ? void 0 : checkbox.required,
      defaultChecked,
      value: checkbox.value
    }
  ), /* @__PURE__ */ React.createElement("label", { htmlFor: label.for, dangerouslySetInnerHTML: { __html: textHtml } }));
};
FormBuilderFormInterfaceCommunityConsent.displayName = "FormBuilderFormInterfaceCommunityConsent";
export default FormBuilderFormInterfaceCommunityConsent;
